// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/super_offers/index.css
// module id = 1871
// module chunks = 0